import { render, staticRenderFns } from "./costsheet.vue?vue&type=template&id=648883a1"
import script from "./costsheet.vue?vue&type=script&lang=js"
export * from "./costsheet.vue?vue&type=script&lang=js"
import style0 from "./costsheet.vue?vue&type=style&index=0&id=648883a1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports